import MapKey from './MapKey'

export default MapKey
